<template>
	<Row class="page-container-row">
		<Col
			:span="24" :offset="0"
			:lg="{ span: 12, offset: 6 }"
			:xl="{ span: 10, offset: 7 }"
			:xxl="{ span: 8, offset: 8 }"
		>
			<PageContainer>
				<Row :gutter="[16, 8]">
					<Col :span="24">
						<TypographyTitle :level="2">{{ $t('info.header') }}</TypographyTitle>
					</Col>
				</Row>
				<Row :gutter="[16, 8]">
					<Card :bordered="false" class="width-100">
						<IpPortAccessForm :adminAccess="false" :loading="isLoading" :status="statusData" />
					</Card>
				</Row>
			</PageContainer>
		</Col>
	</Row>
</template>

<script>
import { ref, onMounted } from 'vue';
import { Row, Col, TypographyTitle, Card } from 'ant-design-vue';

import Api from '@/api/Api';

import PageContainer from '@/components/common/PageContainer';
import IpPortAccessForm from '@/components/settings/IpPortAccessForm';


export default {
	components: {
		Row, Col, TypographyTitle, Card,
		PageContainer, IpPortAccessForm,
	},
	setup() {
		const isLoading = ref(true);
		const statusData = ref({});
		const handleVrsSettingsGet = responseData => {
			statusData.value = responseData.statusData;
			isLoading.value = false;
		};
		const fetchSettings = () => {
			isLoading.value = true;
			Api.vrsInfoGet(handleVrsSettingsGet);
		};
		onMounted(fetchSettings);
		return {
			isLoading,
			statusData,
		};
	},
}
</script>
